<template>
    <div ref="add_photo"></div>
</template>

<script>
import AddPhoto from "!!raw-loader!../../assets/ricoh_assets/icons/ICN004-02_add_photo.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.add_photo.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = AddPhoto

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>
</style>